export enum ReliabilityFofReasonType {
  Misuse = 1,
  Nff = 2,
  Cid = 3,
  CustomerOriginatedComponent = 4,
  TsiNotZero = 5,
  Other = 6,
}

export const ReliabilityFoFRejectReasonType = [
  { key: "MISUSE", value: ReliabilityFofReasonType.Misuse },
  { key: "NFF", value: ReliabilityFofReasonType.Nff },
  { key: "CID", value: ReliabilityFofReasonType.Cid },
  { key: "OTHER", value: ReliabilityFofReasonType.Other },
];

export const ReliabilityNotFoFReasonType = [
  { key: "CUSTOMER ORIGINATED COMPONENT", value: ReliabilityFofReasonType.CustomerOriginatedComponent },
  { key: "TSI NOT ZERO", value: ReliabilityFofReasonType.TsiNotZero },
  { key: "OTHER", value: ReliabilityFofReasonType.Other },
];

export const ReliabilityFofReasonChoices = [...ReliabilityFoFRejectReasonType, ...ReliabilityNotFoFReasonType];
